import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { RolElement, UserElement } from '../models/user.model';
import { WorkerService } from '../services/worker.service';
import { MenusComponent } from './../menus/menus.component';
import { MatPaginator } from '@angular/material/paginator';
import { WorkerElement } from '../models/worker.model';
import { StorageService } from '../services/storage.service';

const lstUsers: WorkerElement[] = [];

@Component({
  selector: 'app-workers',
  templateUrl: './workers.component.html',
  styleUrl: './workers.component.css',
})

export class WorkersComponent implements OnInit {

  private rowClick$  = new Subject<WorkerElement>();

  displayedColumns:  string[] = ['id', 'first_name', 'last_name'];
  displayedColumns2: string[] = ['id', 'first_name', 'last_name', 'dni', 'company_id', 'device'];


  dataSource = new MatTableDataSource(lstUsers);

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private router: Router, private workerService: WorkerService,
              private menusComponent: MenusComponent, public storageService: StorageService) { }

  isLoading = false;

  @ViewChild(MatSort)
  sort: MatSort = new MatSort;
  public superAdm = false;
  
  items: any = [];
  lstRoles: RolElement[] = [];

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.paginator._intl.itemsPerPageLabel="Registros por página";
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.rowClick$.subscribe(
      row => console.log('[row clicked]', row)
    );
    console.log("estamos en workers")
    this.isLoading = true;

    this.loadWorkers();
    this.isLoading = false;
  }

  loadWorkers():void {
    const req=this.workerService.getAllWorkers(this.storageService.companyId);
    req.subscribe({
      next: (res) => {
        this.items = res;
        this.dataSource.data=this.items.data;
      },
      error: (e) => {
        console.error(e);
        let msg = e.error.message;
      },
    });
  }

  onRowClicked(row: WorkerElement): void {
    this.rowClick$.next(row);
    this.router.navigate(['worker'], { queryParams: { id: row.id, companyId: row.company_id } });
  }
  
  getRoleLabel(companyId: number): string {
    const company = this.lstRoles.find(comp => comp.value === companyId);
    return company ? company.viewValue : 'Unknown';
  }
}
